import * as React from 'react'
import { SyntheticEvent } from 'react'
import { Dispatch, connect } from 'react-redux'
import { compose } from 'react-apollo'

import { Form as StyledForm } from '../../../Styled/Shared'
import { CountryType, withCountries } from '../../../Shared/CountryOptions'
import {
  getProjectLocation,
  getIsNewProject
} from '../../../../reducers/project'
import { selectCountry } from '../../../../actions/project'
import { Store } from '../../../../reducers'
import { Action } from '../../../../actions/types'
import CustomSelect from '../../../Shared/CustomSelect'
import * as R from 'ramda'

const CountryOpt = ({ id, displayName }) => (
  <option value={id}>{displayName}</option>
)

type ExternalProps = {
  selectedCountry: string
  isNew: boolean
  selectCountry: (country: string) => Action
  countries: CountryType[]
}

type Props = ExternalProps

class LocationEditor extends React.Component<Props> {
  selectCountry = (e: SyntheticEvent<HTMLSelectElement>) => {
    this.props.selectCountry(e.currentTarget.value)
  }

  parseOptions() {
    return this.props.countries.map((country, indx) => (
      <CountryOpt key={indx} {...country} />
    ))
  }

  render() {
    // Find location display name regardless is location country id or country name
    const locationName = (
      R.find(
        c => c.id === this.props.selectedCountry,
        this.props.countries
      ) || { displayName: this.props.selectedCountry }
    ).displayName

    return (
      <StyledForm>
        <h4>LOCATION</h4>

        <label htmlFor="beam.type">
          Location
          {this.props.isNew ? (
            <CustomSelect
              options={this.parseOptions()}
              currentVal={this.props.selectedCountry}
              handleEventChange={this.selectCountry}
            />
          ) : (
            <input disabled={true} value={locationName} />
          )}
        </label>
      </StyledForm>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  selectedCountry: getProjectLocation(state),
  isNew: getIsNewProject(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  selectCountry: (country: string) => dispatch(selectCountry(country))
})

export default compose(
  withCountries,
  connect(mapStateToProps, mapDispatchToProps)
)(LocationEditor)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/Editors/LocationEditor.tsx